import React, { useState } from "react";
import {
  DialogTitle,
  DialogContentText,
  DialogContent,
  Dialog,
  IconButton,
  DialogActions,
} from "@mui/material";
import axios from "axios";
import { BaseUrl, emailservice } from "../../../../Container/BaseUrl/BaseUrl";
import { connect } from "react-redux";
import { GetAllUsers } from "../../../../Redux/Actions/actions";
import MessageSummeryComponent from "../MessageSummeryComponent/MessageSummeryComponent";
import moment from "moment";
import { ChatText } from "@phosphor-icons/react";
import Button from "@mui/material/Button";
import { HiChatBubbleLeftRight } from "react-icons/hi2";
import { FaFacebookF, FaPhone, FaVideo } from "react-icons/fa6";
import { RiRobot2Fill, RiWhatsappFill } from "react-icons/ri";
import { MdEmail } from "react-icons/md";
import { BsTwitterX } from "react-icons/bs";
import { AiFillInstagram } from "react-icons/ai";

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
  };
};

const SummeryComponent = (props) => {
  const { OpenDialog, handleClose, summerydata } = props;
  let agent_one = summerydata[0].agent.username;
  let agent_two = summerydata[1].confUser;
  const [summaryArrivalDate, setSummaryArrivalDate] = useState(
    summerydata[0].arrival_at
  );
  const [summaryChannel, setSummaryChannel] = useState(summerydata[0].channel);
  const [summaryAgent, setSummaryAgent] = useState(agent_one + agent_two);
  const [summaryStartedDate, setSummaryStartedDate] = useState(
    summerydata[0].chat_started_at
  );
  const [summaryEndDate, setSummaryEndDate] = useState(
    summerydata[0].chat_ended_at
  );
  const [ticketid, setTicketid] = useState(summerydata[0].ticketID);
  const [comments, setcomments] = useState(summerydata[0].comments);
  const [showMessageSummery, setShowMessageSummery] = useState(false);
  const [ChatHistory, setChatHistory] = useState([]);
  const [Sessionvalforemail, setSessionvalforemail] = useState([]);
  const handlechatShow = async () => {
    try {
      let data = {
        sessionId: summerydata[0].chat_session_id,
      };
      const chatHistory = await axios.post(
        BaseUrl + "/message/chatHistories/",
        data,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      );

      if (chatHistory.data.status) {
        setChatHistory(chatHistory.data.data);
        setShowMessageSummery(true);
      } else {
      }
    } catch (error) {}
  };

  const getSessionsDetailsForEmail = async (value) => {
    const access_token = localStorage.getItem("access_token");
    const tenantId = localStorage.getItem("TenantId");

    await axios
      .post(
        emailservice + "/fetchEmailSummary",
        {
          sessionId: props.externalChatData
            ? props.externalChatData.chat_session_id
            : "",
          ticketID: summerydata[0] ? summerydata[0].ticketID : "",
        },
        {
          headers: {
            Authorization: "Bearer " + access_token,
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setSessionvalforemail(res.data.Data);
          setShowMessageSummery(true);
        } else {
          setShowMessageSummery(false);
          setSessionvalforemail([]);
        }
      });
  };

  return (
    <>
      <Dialog
        open={OpenDialog}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          variant="subtitle2"
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            boxShadow:
              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
          }}
        >
          Summary
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            className="mt-3"
            sx={{ display: "flex", justifyContent: "center", gap: 2 }}
          >
            <div className="w-100">
              <div className="table-responsive  vhm-60 mb-0">
                <table className="mb-0 table fs-13  table-hover align-middle table-fix">
                  <thead>
                    <tr className="table-primary">
                      <th scope="col">Arrival At</th>
                      <th scope="col">Started At</th>
                      <th scope="col">Comments</th>
                      <th scope="col">Ended At</th>
                      <th scope="col">Channel</th>
                      <th scope="col">Agent</th>
                      <th scope="col">View</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="text-break">
                      <td> {moment(summaryArrivalDate).format("lll")}</td>
                      <td> {moment(summaryStartedDate).format("lll")}</td>
                      <td>{comments ? comments : "NA"}</td>
                      <td>
                        {summaryEndDate
                          ? moment(summaryEndDate).format("lll")
                          : "--"}
                      </td>
                      <td align="center">
                        {(() => {
                          switch (summaryChannel) {
                            case "webchat":
                              return (
                                <div className="twit-bg chat-social d-flex justify-content-center align-items-center">
                                  <HiChatBubbleLeftRight size={10} />
                                </div>
                              );
                            case "instagram":
                              return (
                                <div className="inst-bg chat-social d-flex justify-content-center align-items-center">
                                  <AiFillInstagram size={10} />
                                </div>
                              );
                            case "from_whatsapp":
                              return (
                                <div className="what-bg chat-social d-flex justify-content-center align-items-center">
                                  <RiWhatsappFill size={10} />
                                </div>
                              );
                            case "voice":
                              return (
                                <div className="what-bg chat-social d-flex justify-content-center align-items-center">
                                  <FaPhone size={10} />
                                </div>
                              );
                            case "from_facebook":
                              return (
                                <div className="fb-bg chat-social d-flex justify-content-center align-items-center">
                                  <FaFacebookF size={10} />
                                </div>
                              );
                            case "from_twitter":
                              return (
                                <div className="twit-bg chat-social d-flex justify-content-center align-items-center">
                                  <BsTwitterX size={10} />
                                </div>
                              );
                            case "email":
                              return (
                                <div
                                  className="twit-bg chat-social d-flex justify-content-center align-items-center"
                                  style={{ background: "" }}
                                >
                                  <MdEmail size={10} />
                                </div>
                              );
                            case "from_purple":
                              return (
                                <div className="twit-bg chat-social d-flex justify-content-center align-items-center">
                                  <RiRobot2Fill size={10} />
                                </div>
                              );
                            default:
                              return (
                                <div className="twit-bg chat-social d-flex justify-content-center align-items-center">
                                  <FaVideo size={10} />
                                </div>
                              );
                          }
                        })()}
                      </td>
                      <td>{summaryAgent}</td>
                      <td>
                        {summaryChannel == "voice" ||
                        summaryChannel == "videochat" ? (
                          <></>
                        ) : (
                          <IconButton
                            size="small"
                            onClick={() => {
                              if (summaryChannel == "email") {
                                getSessionsDetailsForEmail();
                              } else {
                                handlechatShow();
                              }
                            }}
                          >
                            <ChatText size={14} weight="bold" />
                          </IconButton>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ textTransform: "capitalize !important" }}
            variant="outlined"
            onClick={() => {
              handleClose();
            }}
            size="small"
            disableElevation
            color="error"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {showMessageSummery && (
        <MessageSummeryComponent
          OpenDialog={showMessageSummery}
          summerydata={summerydata}
          ChatHistory={ChatHistory}
          Sessionvalforemail={Sessionvalforemail}
          handleClose={() => {
            setShowMessageSummery(false);
          }}
        />
      )}
    </>
  );
};

export default connect(mapStateToProps, {
  GetAllUsers,
})(SummeryComponent);
